import { Component, OnInit } from '@angular/core';
import { UserService } from '../../layout/service/user.service';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-category',
    imports: [
        ButtonModule,
        DialogModule,
        TableModule,
        TagModule,
        FormsModule,
        InputTextModule,
        SelectModule,
        ToastModule
    ],
    providers: [MessageService],
    template: `
        <p-toast />
        <div class="card">
            <div class="flex justify-between items-center">
                <h3 class="text-primary">Manajemen Kategori</h3>
                <p-button severity="success" label="Tambah Kategori" (click)="addCategory()" icon="pi pi-plus"></p-button>
            </div>
            <p-table #dt [value]="categories" stripedRows [tableStyle]="{ 'min-width': '50rem' }" [rowHover]="true" [rows]="10"
                [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]" [loading]="loading"
                [paginator]="true" currentPageReportTemplate="Menampilkan {first} sampai {last} dari {totalRecords} entri"
                [filterDelay]="0" [globalFilterFields]="['KATEGORI']"
                [rowGroupMode]="'subheader'" groupRowsBy="LEVEL" [sortField]="'LEVEL'" [sortOrder]="1">

                <ng-template pTemplate="caption">
                    <div class="flex items-center">
                        <div>
                            <input pInputText type="text" (input)="onInput($event, dt)" placeholder="Cari kata kunci" />
                        </div>
                    </div>
                </ng-template>

                <ng-template #header>
                    <tr>
                        <th class="w-20 text-center">No</th>
                        <th>Kategori</th>
                        <th class="w-25">Status</th>
                        <th class="w-20">Aksi</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-category let-i="rowIndex">
                    <tr>
                        <td>{{ i + 1 }}</td>
                        <td>{{ category.KATEGORI }}</td>
                        <td>
                            <p-tag
                                [value]="category.IS_ACTIVED == 1 ? 'Aktif' : 'Tidak Aktif'"
                                [severity]="category.IS_ACTIVED == 1 ? 'success' : 'danger'">
                            </p-tag>
                        </td>
                        <td>
                            <p-button icon="pi pi-pencil" variant="text" [raised]="true" severity="warn" class="mr-2" (click)="editCategory(category)"></p-button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="groupheader" let-category>
                    <span class="font-bold text-lg">{{ category.LEVEL }}</span>
                </ng-template>
            </p-table>
        </div>

        <p-dialog
            header="Tambah Kategori"
            [(visible)]="addDialog"
            [modal]="true"
            [style]="{ width: '35rem' }"
            position="top"
            draggable="false">
            <span class="text-surface-500 dark:text-surface-400 block mb-8">
                Tambahkan kategori baru.
            </span>
            <div class="flex flex-col gap-2 mb-4">
                <label for="newCategoryName" class="font-semibold w-24">Kategori</label>
                <input pInputText [(ngModel)]="newCategory.KATEGORI" id="newCategoryName" class="flex-auto" autocomplete="off" />
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label for="newCategoryLevel" class="font-semibold w-24">Level</label>
                <p-select
                    [options]="levelOptions"
                    [(ngModel)]="newCategory.LEVEL"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Pilih Level" appendTo="body"
                    class="w-full">
                </p-select>
            </div>
            <ng-template #footer>
                <p-button label="Batal" [text]="true" severity="secondary" (click)="addDialog = false" />
                <p-button label="Simpan" [outlined]="true" severity="secondary" (click)="saveNewCategory()" />
            </ng-template>
        </p-dialog>

        <p-dialog
            header="Ubah Kategori"
            [(visible)]="editDialog"
            [modal]="true"
            [style]="{ width: '35rem' }"
            position="top"
            draggable="false">
            <span class="text-surface-500 dark:text-surface-400 block mb-8">
                Perbarui informasi kategori.
            </span>
            <div class="flex flex-col gap-2 mb-4">
                <label for="categoryName" class="font-semibold w-24">Kategori</label>
                <input pInputText [(ngModel)]="selectedCategory.KATEGORI" id="categoryName" class="flex-auto" autocomplete="off" />
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label for="categoryLevel" class="font-semibold w-24">Level</label>
                <p-select
                    [options]="levelOptions"
                    [(ngModel)]="selectedCategory.LEVEL"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Pilih Level" appendTo="body"
                    class="w-full">
                </p-select>
            </div>
            <div class="flex flex-col gap-2 mb-4">
                <label for="status" class="font-semibold w-24">Status</label>
                <p-select
                    [options]="statusOptions"
                    [(ngModel)]="selectedCategory.IS_ACTIVED"
                    optionLabel="label"
                    placeholder="Pilih Status" appendTo="body"
                    class="w-full">
                </p-select>
            </div>
            <ng-template #footer>
                <p-button label="Batal" [text]="true" severity="secondary" (click)="editDialog = false" />
                <p-button label="Simpan" [outlined]="true" severity="secondary" (click)="saveCategory()" />
            </ng-template>
        </p-dialog>
    `
})
export class Category implements OnInit {
    categories: any[] = [];
    loading: boolean = true;
    editDialog: boolean = false;
    addDialog: boolean = false;
    selectedCategory: any = {};
    newCategory: any = { KATEGORI: '', LEVEL: '' };
    statusOptions = [
        { label: 'Aktif', value: 1 },
        { label: 'Tidak Aktif', value: 0 }
    ];
    levelOptions = [
        { label: 'UKNPDPD', value: 'UKNPDPD' },
        { label: 'Preklinik', value: 'Preklinik' },
        { label: 'Koas', value: 'Koas' }
    ];

    constructor(
        private userService: UserService,
        private messageService: MessageService
    ) { }

    ngOnInit(): void {
        this.userService.getCategories().then((response) => {
            this.categories = response.data;
            this.categories.sort((a, b) => (a.LEVEL || '').localeCompare(b.LEVEL || ''));
            this.loading = false;
        }).catch(() => {
            console.error('Error fetching categories');
            this.loading = false;
        });
    }

    onInput(event: Event, dt: any) {
        const inputElement = event.target as HTMLInputElement;
        dt.filterGlobal(inputElement.value, 'contains');
    }

    addCategory() {
        this.newCategory = {
            KATEGORI: '',
            LEVEL: '',
            IS_ACTIVED: 1
        };
        this.addDialog = true;
    }

    saveNewCategory() {
        this.userService.addCategory(this.newCategory).then((response) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Category added successfully' });
            this.categories.push(this.newCategory);
            this.newCategory = { KATEGORI: '', LEVEL: '' };
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to add category' });
        })
        this.addDialog = false;
    }

    editCategory(category: any) {
        this.selectedCategory = { ...category };
        this.selectedCategory.IS_ACTIVED = this.statusOptions.find(status => status.value == category.IS_ACTIVED);
        this.editDialog = true;
    }

    saveCategory() {
        this.selectedCategory.IS_ACTIVED = this.selectedCategory.IS_ACTIVED.value;
        this.userService.editCategory(this.selectedCategory).then((response) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Category updated successfully' });
            const index = this.categories.findIndex((cat) => cat.ID === this.selectedCategory.ID);
            if (index !== -1) {
                this.categories[index] = this.selectedCategory;
            }
            this.ngOnInit();
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update category' });
        })
        this.editDialog = false;
    }
}
